
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeaturedPost from './components/FeaturedPost';
import BlogGrid from './components/BlogGrid';
import NewsletterSection from './components/NewsletterSection';

const BlogPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <HeroSection />
        <FeaturedPost />
        <BlogGrid />
        <NewsletterSection />
      </main>
      <Footer />
    </div>
  );
};

export default BlogPage;
